__turbopack_context__.v({
  "header": "styles-module-scss-module__D2YBJG__header",
  "input_container": "styles-module-scss-module__D2YBJG__input_container",
  "input_label": "styles-module-scss-module__D2YBJG__input_label",
  "minmax_select_container": "styles-module-scss-module__D2YBJG__minmax_select_container",
  "multiple_select_heading": "styles-module-scss-module__D2YBJG__multiple_select_heading",
  "remove_label": "styles-module-scss-module__D2YBJG__remove_label",
  "select": "styles-module-scss-module__D2YBJG__select",
  "select_container": "styles-module-scss-module__D2YBJG__select_container",
  "theme_request_modal": "styles-module-scss-module__D2YBJG__theme_request_modal",
});
